import Vue from 'vue'
import Vuex from 'vuex'
import qs from 'qs'
import { createHash } from '@/helpers/functions.js'

Vue.use(Vuex)


let apiBaseURL = 'https://dev.debeitsyou.de/index.php?route=konfiguratorAPI/debe_box'

if (process.env.VUE_APP_GCLOUD_VERSION === 'staging') {
  apiBaseURL = 'https://staging.debeitsyou.de/index.php?route=konfiguratorAPI/debe_box'
} else if (process.env.VUE_APP_GCLOUD_VERSION === 'prod') {
  apiBaseURL = 'https://debeitsyou.de/index.php?route=konfiguratorAPI/debe_box'
}

export default new Vuex.Store({
  
  state: {
    apiBaseURL,
    activeProduct: null,
    hash: null,
    persId: null,
    persText: null,
    persTextColor: null,
    persTextFont: null,
    persImg: null,
    konvaStage: null,
    persImgParameters: null,
    
  },
  mutations: {
    setKonvaStage: function (state, val) {
      state.konvaStage = val
    },
    setActiveProduct: function (state, val) {
      state.activeProduct = val
    },
    setPersId: function (state, val) {
      state.persId = val
    },
    setPersText: function (state, val) {
      state.persText = val
    },
    setPersTextColor: function (state, val) {
      state.persTextColor = val
    },
    setPersTextFont: function (state, val) {
      state.persTextFont = val
    },
    setPersImg: function (state, val) {
      state.persImg = val
    },
    setPersImgParameters: function (state, val) {
      state.persImgParameters = val
    },
  },
  
  actions: {
    setKonvaStage: function (context, val) {
      context.commit('setKonvaStage', val.getStage())
    },
    setActiveProduct: function (context, val) {
      context.commit('setActiveProduct', val)
    },
    registerBackend: function (context, val) {
      Vue.axios.post(context.state.apiBaseURL + '/register', qs.stringify({
      prodId: context.state.activeProduct,
      designId: context.state.activeDesign
      })).then((response) => {
        if (response.data.status === 'success') {         
          context.commit('setPersId', response.data.persId)
        }
      })
    },
    setPersText: function ( context, val) {
      context.commit('setPersText', val)
    },
    setPersTextFont: function ( context, val) {
      context.commit('setPersTextFont', val)
    },
    setPersTextColor: function ( context, val) {
      context.commit('setPersTextColor', val)
    },
    setPersImg: function ( context, val) {
      context.commit('setPersImg', val)
    },
    setPersImgParameters: function ( context, val) {
      context.commit('setPersImgParameters', val)
    },
    addToCart: function (context) {  
      //console.log(context.state.persImg)
      
      console.log({
        persId: context.state.persId,
        type: 'order',
        //otherproducts: context.state.otherProducts,
        prodId: context.state.activeProduct,
        
        persText: context.state.persText,
        
        //total: Number.parseFloat((store.state.basePrice * store.state.boxes.filter((x) => { return x.side === 0 && x.group !== null }).length)).toFixed(2)
      })
      parent.postMessage({
        persId: context.state.persId,
        type: 'order',
        //otherproducts: context.state.otherProducts,
        prodId: context.state.activeProduct,
        
        persText: context.state.persText,
        
        //total: Number.parseFloat((store.state.basePrice * store.state.boxes.filter((x) => { return x.side === 0 && x.group !== null }).length)).toFixed(2)
      }, '*')
    },
    takePreviewImg: function(context) {
      setTimeout(function () {
      let x=50
      let y=110
      if(context.state.persText) {
        x=290
        y=100 } 
      context.state.konvaStage.toImage({
        mimeType: 'image/jpeg',        
        x:x,
        y:y, 
        width:350,
        height:350,

        callback: (img1) => {
          window.localStorage.setItem("imgData",img1);          
          let filename= null
          let img= null
          if (img1) {
            filename=context.state.hash+".png"
            img=img1.src
          }
          Vue.axios.post(context.state.apiBaseURL + '/setDataS4F', qs.stringify({
            persId: context.state.persId,
            prodId: context.state.activeProduct,  
            persText: context.state.persText,
            persTextFont: context.state.persTextFont,
            persTextColor: context.state.persTextColor,            
            persImgParameters:  JSON.parse(JSON.stringify(context.state.persImgParameters)),
            img: img1.src, 
            filename: filename          
          })).then((response) => {
            if (response.data.status === 'success') {
              
              //context.commit('setPersId', response.data.persId)
              }
            })
          
        }
        

      })
    },800)
   
    },
    uploadImage: function (context) {
      var hash = createHash()
     
      Vue.axios.post(context.state.apiBaseURL + '/uploadImageS4F', qs.stringify({
        persId: context.state.persId,
        image: context.state.persImg,
        filename: hash

        })).then((response) => {
          if (response.data.status === 'success') {            
            //context.commit('setPersId', response.data.persId)
            }
          })

      
    },
  },
  modules: {
  }
})
